import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import $ from 'jquery'
import Toggle from "react-toggle";
import Icon from "../common/icon/icon.component.jsx";

class LiveQuote extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            quoteId: this.props.quoteId || '',
            liveQuoteVideoEnabled: true,
        }

        this.onClose = this.props.onClose

        this.closeModals = this.closeModals.bind(this)
        this.submit = this.submit.bind(this)
    }

    submit(event) {
        AppContext.getApiClient().patch('/quotes/'+this.state.quoteId, {
            liveQuoteStatus: 'running',
            liveQuoteVideoEnabled: this.state.liveQuoteVideoEnabled,
        }).then(_ => this.closeModals(event))
    }


    componentDidMount() {
        $('#liveQuoteModal').modal('show')
    }


    closeModals(event) {
        event.preventDefault()
        $('#liveQuoteModal').modal('hide')
        this.onClose()
    }


    render() {
        return (
            <div>
                {/************** Discount quote Modal ***************/}
                <div className="modal fade"
                    id="liveQuoteModal"
                    role="dialog"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                                    <Icon value={"desktop"} className={"mr-2"} />
                                    <FormattedMessage
                                        id="quote.live_quote_setup.title"
                                        defaultMessage="Start Live Quote"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className={'w-100 mb-3'}>
                                        <small>
                                            <FormattedMessage
                                                id="quote.live_quote_setup.details"
                                                defaultMessage="Live quote mode allows you to share the quote with your customer and edit it as you speak with them remotely"
                                            />
                                        </small>
                                    </div>
                                    <div className="form-group row mb-0">
                                        <label className="col-9 col-form-label" htmlFor="liveQuoteVideoEnabled">
                                            <FormattedMessage
                                                id="quote.live_quote_setup.enable_video"
                                                defaultMessage="Embed conference call with customer"
                                            />
                                        </label>
                                        <div className="col-3 d-flex align-items-center">
                                            <div className="input-group">
                                                <Toggle
                                                    id={'liveQuoteVideoEnabled'}
                                                    defaultChecked={this.state.liveQuoteVideoEnabled}
                                                    checked={this.state.liveQuoteVideoEnabled}
                                                    icons={false}
                                                    onChange={() => {
                                                        this.setState({
                                                            liveQuoteVideoEnabled: !this.state.liveQuoteVideoEnabled
                                                        })
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.live_quote_setup.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <button type="button" className="btn btn-primary" onClick={this.submit}>
                                    <FormattedMessage
                                        id="quote.live_quote_setup.submit_btn"
                                        defaultMessage="Enable live quote mode"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(LiveQuote)





// WEBPACK FOOTER //
// ./src/quote/livequote.component.jsx